import {
  Box,
  Flex,
  Stack,
} from "@mantine/core";
import CardHeader from "./CardHeader";
import { useContext, useState } from "react";
import { MentionProvider } from "../../../MentionTextarea/MentionContext";
import IdeaContext from "../../IdeaContext";
import CardScroller from "./CardScroller";
import DiscoveryContext from "../../../Discovery/DiscoveryContext";
import GeneratedActions from "./actions/GeneratedActions";
import CardHeaderDiscoveryAndCustomer from "../../../Discovery/evidenceCard/evidence-card/CardHeaderDiscoveryAndCustomer";
import SingleCustomerContext from "../../../Customer360/Customer-Context/SingleCustomerContext";
import CustomerActions from "./actions/CustomerActions";
import EvidenceActions from "./EvidenceActions";
import AiEvidenceActions from "./AiEvidenceActions";


const SideBar = ({
  navToPerspective,
  setActiveSearch,
  reviewMode,
  componentType,
  chosenEvidence,
  isGenerated: propIsGenerated,
  setChosenEvidence: propSetChosenEvidence,
  idea: propIdea,
  loadEvidence: propLoadEvidence,
  getUnreadNotificationsCountByRequest: propGetUnreadNotificationsCountByRequest,
  isLoadingMl = false
}: {
  navToPerspective: any;
  setActiveSearch: any;
  reviewMode: boolean;
  componentType: 'idea' | 'discovery' | 'customer' | 'ai';
  chosenEvidence: any;
  isGenerated?: boolean;
  setChosenEvidence?: (evidence: any) => void;
  idea?: any;
  loadEvidence?: () => void;
  getUnreadNotificationsCountByRequest?: (requestId: string) => number;
  isLoadingMl?: boolean;
}) => {

  const isIdeaPage: boolean = componentType === 'idea'
  const isDiscoveryPage: boolean = componentType === 'discovery'
  const isCustomerPage: boolean = componentType === 'customer'
  const isIdeaAi: boolean = componentType === 'ai'

  const ContextToUse: React.Context<any> = 
  isIdeaPage ? IdeaContext : isDiscoveryPage ? DiscoveryContext : SingleCustomerContext;

  const contextData = useContext(ContextToUse);
  
  // Use chosenEvidence from props if isIdeaAi, otherwise from context
  const { chosenEvidence: contextChosenEvidence, isGenerated: contextIsGenerated , idea : contextIdea , loadEvidence: contextLoadEvidence} = contextData;
  const finalChosenEvidence = (isIdeaAi || isCustomerPage) ? chosenEvidence : contextChosenEvidence;



  const finalLoadEvidence = isIdeaAi ? propLoadEvidence : contextLoadEvidence;
  
  const finalIsGenerated = isIdeaAi ? propIsGenerated : contextIsGenerated;
  const finalIdea = isIdeaAi ?propIdea : contextIdea;
  const [componentId, setComponentId] = useState(finalChosenEvidence?.componentObj?._id);
  const status = finalChosenEvidence?.status; 
  const isAssigned: boolean = finalChosenEvidence?.ideaId === finalIdea?._id && finalChosenEvidence?.state === 'validated'
  const isRequestInreview : boolean = finalChosenEvidence?.state === 'inReview' && !finalChosenEvidence?.match
  const isGapMatch: boolean = finalChosenEvidence?.match && finalChosenEvidence?.type === 'gap'
  const isRequestMatch: boolean = finalChosenEvidence?.match && finalChosenEvidence?.type === 'request'

  return (
    // h="calc(100vh - 137px)"
    <Box h={isIdeaAi ? "calc(100vh - 377px)" : isCustomerPage? 'calc(100vh - 332px)' : isDiscoveryPage ? "calc(100vh - 108px)" : '100%'} >
      <MentionProvider>
        <Stack justify="space-between" h={isIdeaAi ? '100px' : isCustomerPage ? 'calc(100vh - 332px)' : isDiscoveryPage ? "calc(100vh - 108px)" : '100%'}  >
          <Box h={isCustomerPage ? 'calc(100vh - 396px)' : undefined}>
            {isIdeaPage || isIdeaAi ?
              <Flex
                mt="24px"
                pb="16px" 
                px="35px"
                justify="space-between"
                align="center"
                sx={{ borderBottom: "1px solid #D8D8DB" }}
              >
               
                <CardHeader 
                  navToPerspective={navToPerspective}
                  validationCount={0}
                  chosenEvidence={isIdeaAi ? finalChosenEvidence : undefined}
                  setChosenEvidence={isIdeaAi ? propSetChosenEvidence : undefined}
                  idea={isIdeaAi ? finalIdea : undefined}
                  isIdeaAi={isIdeaAi}
                /> 
                
              
              </Flex> : isDiscoveryPage ? 
                <Flex
                  mt="24px"
                  pb="16px" 
                  px="35px"
                  justify="space-between"
                  align="center"
                  sx={{ borderBottom: "1px solid #D8D8DB" }}
                >
                  <CardHeaderDiscoveryAndCustomer isDiscoveryPage/> 
                </Flex>
                : <></>}
            <CardScroller 
              chosenEvidence={finalChosenEvidence} 
              ideaPage={isIdeaPage}
              componentId={componentId}
              setComponentId={setComponentId}
              isCustomerPage={isCustomerPage}
              idea={isIdeaAi ? finalIdea : undefined}
              loadEvidence={finalLoadEvidence}
              isIdeaAi={isIdeaAi}
              isLoadingMl={isLoadingMl}
            />
          </Box>
          {isIdeaAi ? (
            <AiEvidenceActions
              isIdeaPage={isIdeaPage}
              isIdeaAi={isIdeaAi}
              finalIsGenerated={finalIsGenerated}
              isGapMatch={isGapMatch}
              isRequestMatch={isRequestMatch}
              isRequestInreview={isRequestInreview}
              isAssigned={isAssigned}
              status={status}
              navToPerspective={navToPerspective}
              componentId={componentId}
              finalChosenEvidence={finalChosenEvidence}
              componentType={componentType}
              propGetUnreadNotificationsCountByRequest={propGetUnreadNotificationsCountByRequest}
              setActiveSearch={setActiveSearch}
            />
          ) : (
            <EvidenceActions
              isIdeaPage={isIdeaPage}
              isIdeaAi={isIdeaAi}
              finalIsGenerated={finalIsGenerated}
              isGapMatch={isGapMatch}
              isRequestMatch={isRequestMatch}
              isRequestInreview={isRequestInreview}
              isAssigned={isAssigned}
              status={status}
              navToPerspective={navToPerspective}
              componentId={componentId}
              finalChosenEvidence={finalChosenEvidence}
              componentType={componentType}
              propGetUnreadNotificationsCountByRequest={propGetUnreadNotificationsCountByRequest}
              setActiveSearch={setActiveSearch}
            />
          )}
          {(isIdeaPage || isIdeaAi) && finalIsGenerated &&
          
          <GeneratedActions navToPerspective={navToPerspective} componentId={componentId}/>}
          {isCustomerPage &&
          <Stack justify="space-between" h='100%' >
            <CustomerActions chosenEvidence={finalChosenEvidence}/>
          </Stack>
          } 
        </Stack>
      </MentionProvider>
    </Box>
  );
};

export default SideBar;